import React, { useEffect } from 'react';

import { Flex } from '../../components/common/atom/Layout';
import { Text } from '../../components/common/atom/Text';

import ThemeStyle from '../../lib/style/ThemeStyle';

const FrameView = ({ data }) => {
  const frame = { ...data };
  useEffect(() => {}, [data]);

  const {
    previewImage: { storageUri: previewFrame },
    meta: { name: previewFrameName },
  } = frame;

  return (
    <PreviewFrame
      previewFrameName={previewFrameName}
      previewFrame={previewFrame}
    />
  );
};

export default FrameView;

export const PreviewFrame = ({ previewFrame, previewFrameName }) => (
  <Flex
    column
    padding="1rem"
    style={{
      background: ThemeStyle.background.grey,
      borderRadius: '6px',
    }}
  >
    <img
      src={previewFrame}
      alt=""
      width="100%"
      style={{ boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)' }}
    />
    <Text
      size={12}
      color="brownGrey"
      weight="medium"
      textAlign="center"
      style={{ marginTop: '0.938rem' }}
    >
      {previewFrameName}
    </Text>
  </Flex>
);
